<template>
    <a-modal
            :width="'70%'"
            v-model="isIncomingStore"
            title="设备入库"
            :maskClosable="maskClosable"
            @ok="handleOk">
        <DeviceReginSlide v-if="showReginStep" @reginComplete="reginComplete" :reginTotal="reginTotal" />
        <div style="padding:20px;">
            <a-card>
                <a-form>
                    <a-row :gutter="24">
                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='厂商标识' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-general-select ref="ouiSelector" :type="'oui'" :selectedObj="oui"></z-general-select>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='软件版本' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-general-select ref="versionSelector" :type="'version'" :selectedObj="version"></z-general-select>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='设备型号' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-device-type-chooser ref="deviceTypeSelector"  @deviceModelChange="onDeviceModelChange" :option="deviceType"></z-device-type-chooser>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='表带长度' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-general-select ref="lengthSelector" :type="'length'"  :selectedObj="length"></z-general-select>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='归属库' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-general-select ref="storeSelector" :type="'store'" :selectedObj="store"></z-general-select>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='生产日期' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <a-date-picker  size="small" v-model="createTime" format="YYYY-MM-DD" style="width:100%"></a-date-picker>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='发货日期' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <a-date-picker size="small"  v-model="deliverTime" format="YYYY-MM-DD" style="width:100%"></a-date-picker>
                            </a-form-item>
                        </a-col>

                        <a-col  :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='套餐到期时间' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <a-date-picker size="small" v-model="paymentTime" format="YYYY-MM-DD" style="width:100%"></a-date-picker>
                            </a-form-item>
                        </a-col>

                        <a-col   :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='所属机构' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                            </a-form-item>
                        </a-col>

                        <a-col   :md="{span:12}" :lg="{span:8}">
                            <a-form-item label='备注' :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                                <a-textarea v-model="remark" :rows="1"/>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="24" style="margin-top:15px">
                        <a-col>
                            <a-table :dataSource="singleData" :columns="singleColumns" :pagination="false">
                                <template slot="imei" slot-scope="record">
                                    <a-form-item :validateStatus="imei.validateStatus" :help="imei.errorMsg">
                                        <a-input size="small" v-model="imei.value" :placeholder="record.imei"/>
                                    </a-form-item>
                                </template>
                                <template slot="imsi" slot-scope="record">
                                    <a-form-item >
                                        <a-input size="small" v-model="imsi.value" :placeholder="record.imsi"/>
                                    </a-form-item>
                                </template>
                                <template slot="iccid" slot-scope="record">
                                    <a-form-item >
                                        <a-input size="small" v-model="iccid.value" :placeholder="record.iccid"/>
                                    </a-form-item>
                                </template>
                                <template slot="extra" slot-scope="record">
                                    <a-form-item >
                                        <a-input size="small" v-model="extra.value" :placeholder="record.extra"/>
                                    </a-form-item>
                                </template>
                                <template slot="phoneNo" slot-scope="record">
                                    <a-form-item >
                                        <a-input size="small" v-model="phoneNo.value" :placeholder="record.phoneNo"/>
                                    </a-form-item>
                                </template>
                                <template slot="operation" slot-scope="record">
                                    <a-button :disabled="imei.value == ''" @click="addStore(record)" style="margin-bottom: 24px">添加</a-button>
                                </template>
                            </a-table>
                        </a-col>
                        <a-col style="padding-top:10px">
                            <a-upload
                                    :action="uploadUrl"
                                    :format="['xlsx']"
                                    :beforeUpload="beforeUpload"
                                    :showUploadList="false"
                                    @change="handleChange"
                                    :headers="token"
                                    style="padding-right:10px">
                                <a-button size="small" type="primary">
                                    <a-icon type="upload" style="padding-right:4px"/>
                                    导入
                                </a-button>
                            </a-upload>
                            <a-button size="small" style="margin-top:10px" @click="downloadExample">
                                <a-icon type="download" style="padding-right:4px"/>
                                模板下载
                            </a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </div>


        <div v-for="(item,index) in incomingData" :key="index" style="margin-top:15px">
            <span style="padding-right:10px;">{{item.name}}({{item.data.length}}台)</span>
            <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="changeShow(index)">
                <span v-if="item.isShow">收起</span>
                <span v-else>展开</span>
                <a-icon :type="item.isShow ? 'up' : 'down'"/>
            </a>
            <a-input-search v-model="item.searchInput" placeholder="输入IMEI号进行搜索" style="width: 250px;padding-left:20px" @search="onSearch(index)"/>

            <a-table :scroll="{ x: 800 }" :columns="columns" :dataSource="item.filteredData" style="margin-top:15px" :pagination="pagination" v-show="item.isShow">
                <template slot="delete" slot-scope="text, record">
                    <a-popconfirm v-if="item.data.length" title="确认删除" @confirm="onDelete(record.key,index)">
                        <a href="javascript:;">删除</a>
                    </a-popconfirm>
                </template>
            </a-table>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import ZDeviceTypeChooser from '@/components/common/DeviceTypeChooser.vue'
    import ZGeneralSelect from '@/components/common/GeneralSelect.vue'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import DeviceReginSlide from '../../components/common/DeviceReginSlide'
    import ValidUtils from '@/utils/ValidUtils'
    import {export_json_to_excel} from '@/utils/Export2Excel'

    export default {
        name: 'IncomingStore',
        components: {
            ZOrgChooser,
            ZDeviceTypeChooser,
            ZGeneralSelect,
            DeviceReginSlide
        },
        data() {
            return {
                // 是否显示注册进度条
                showReginStep: false,
                // 某一批次注册的设备总数
                reginTotal: 0,
                maskClosable: false,
                uploadUrl:config.api.device_store_upload_url,
                token: {},
                pagination:{pageSize: 5},
                createTime: null,
                paymentTime: null,
                deliverTime: null,
                remark: '',
                orgOption:{
                    showDirect: false,
                    value: "",
                    id: "storeOrg"
                },
                oui:{value: ''},
                version:{value: ''},
                length:{value: ''},
                store:{value: '',disabled:false},
                imei: {value:''} ,
                imsi:{value:''} ,
                iccid: {value:''} ,
                extra: {value: ''},
                phoneNo: {value: ''},
                isIncomingStore:false,
                deviceType: {
                    allowClear: false,
                    value: '',
                    modelName: null
                },
                singleData: [{"imei": 'IMEI', "imsi": 'IMSI', "iccid": 'ICCID', 'extra': 'EXTRA', 'phoneNo': 'phoneNo'}],
                singleColumns: [
                    {
                        title: 'IMEI',
                        dataIndex: 'imei',
                        width: '30%',
                        scopedSlots: { customRender: 'imei' },
                    },
                    {
                        title: 'IMSI',
                        dataIndex: 'imsi',
                        scopedSlots: { customRender: 'imsi' },
                    },
                    {
                        title: 'ICCID',
                        dataIndex: 'iccid',
                        scopedSlots: { customRender: 'iccid' },
                    },
                    {
                        title: '设备号',
                        dataIndex: 'extra',
                        scopedSlots: { customRender: 'extra' },
                    },
                    {
                      title: '电话号码',
                      dataIndex: 'phoneNo',
                      scopedSlots: { customRender: 'phoneNo'}
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        scopedSlots: { customRender: 'operation' },
                    }
                ],
                incomingData: [{
                    name: "手动添加",
                    isShow: false,
                    searchInput: '',
                    filteredData: [],
                    data: []
                }],
                columns: [
                    {
                        title: 'IMEI',
                        dataIndex: 'imei',
                        key: 'imei',
                    },
                    {
                        title: 'IMSI',
                        dataIndex: 'imsi',
                        key: 'imsi',
                    },
                    {
                        title: 'ICCID',
                        dataIndex: 'iccid',
                        key: 'iccid',
                    },
                    {
                        title: '设备号',
                        dataIndex: 'extra',
                        key: 'extra',
                    },
                    {
                        title: '电话号码',
                        dataIndex: 'phoneNo',
                        key: 'phoneNo',
                    },
                    {
                        title: '厂商标识',
                        dataIndex: 'oui',
                        key: 'oui',
                    },{
                        title: '型号',
                        dataIndex: 'modelName',
                        key: 'modelName',
                    },
                    {
                        title: '软件版本',
                        dataIndex: 'version',
                        key: 'version',
                    },
                    {
                        title: '所属机构',
                        dataIndex: 'orgName',
                        key: 'orgName',
                    },
                    {
                        title: '表带长度',
                        dataIndex: 'length',
                        key: 'length',
                    },
                    {
                        title: '生产日期',
                        dataIndex: 'createTime',
                        key: 'createTime',
                    },
                    {
                        title: '发货日期',
                        dataIndex: 'deliverTime',
                        key: 'deliverTime',
                    },
                    {
                        title: '套餐到期时间',
                        dataIndex: 'paymentTime',
                        key: 'paymentTime',
                    },
                    {
                        title: '归属库',
                        dataIndex: 'store',
                        key: 'store',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        "scopedSlots": {
                            "customRender": "delete"
                        },
                        key: 'operation',
                    }
                ]
            }
        },
        created() {
            this.token = {Authorization:'Bearer ' + this.$store.getters.token}
        },
        methods :{
            onDeviceModelChange(model){
                this.deviceType.vlaue = model.id
                this.deviceType.modelName = model.name
            },
            onOrgSelect(org){
                if(org.id != 1){
                    this.store.disabled = true
                }else{
                    this.store.disabled = false
                }
            },
            showIncomingStoreModel() {
                // 判断此时是否正在注册设备
                this.$http.get(config.api.get_devices_regin_status).then((res) => {
                    // console.log(res)
                    let {code, result} = res
                    if (code === 0) {
                        // 判断此时是否正在注册设备
                        if (result.storageFlag) {
                            // 是的话，直接到显示注册进度的页面
                            // console.log('open')
                            this.showReginStep = true
                        } else {
                            // 接原来的操作
                            this.isIncomingStore = true
                            this.incomingData = [{
                                name: "手动添加",
                                isShow: false,
                                searchInput: '',
                                filteredData: [],
                                data: []
                            }];
                            this.createTime = this.$moment().startOf('day')
                            this.paymentTime = this.$moment().add(1, 'years').startOf('day')
                            this.deliverTime = this.$moment().startOf('day')
                            this.remark = ''
                            let _this = this
                            setTimeout(function(){
                                _this.$refs["ouiSelector"].setDefault()
                                _this.$refs["versionSelector"].setDefault()
                                _this.$refs["deviceTypeSelector"].setDefault()
                                _this.$refs["lengthSelector"].setDefault()
                                _this.$refs["storeSelector"].setDefault()
                            },200)
                            if(this.$refs["orgChooser"]){
                                this.$refs["orgChooser"].initOrgTree()
                            }
                        }
                    }
                })
            },
            handleChange(info) {
                if (info.file.status === 'done'){
                    let incomingList = []
                    let uploadList = info.file.response.result.uploadList
                    let timestamp =  info.file.response.result.timestamp
                    let _this = this
                    let repeatNum = 0
                    let incomingNum = 0
                    uploadList.map(function(item){
                        let isRepeat = false
                        _this.incomingData.map(function(record){
                            if(record.data.length !== record.data.filter(subItem => subItem.key !== _this.oui.value + "_" + item.IMEI).length){
                                isRepeat = true
                            }
                        })
                        if(isRepeat){
                            repeatNum ++
                        }else{
                            incomingNum ++
                            incomingList.push({
                                key: _this.oui.value + "_" + item.IMEI,
                                imei: item.IMEI,
                                imsi: item.IMSI,
                                iccid: item.ICCID,
                                extra: item.EXTRA,
                                phoneNo: item.phoneNo,
                                orgId: _this.orgOption.orgId,
                                orgName:_this.orgOption.name,
                                oui: _this.oui.value,
                                modelId : _this.deviceType.value,
                                modelName:  _this.deviceType.modelName,
                                version: _this.version.value,
                                length: _this.length.value,
                                store: _this.store.value,
                                createTime: _this.createTime == null ? null : _this.createTime.format("YYYY-MM-DD"),
                                createTimeStamp: _this.createTime == null ? null : _this.createTime.valueOf(),
                                paymentTime: _this.paymentTime == null ? null : _this.paymentTime.format("YYYY-MM-DD"),
                                paymentTimestamp: _this.paymentTime == null ? null : _this.paymentTime.valueOf(),
                                deliverTime: _this.deliverTime == null ? null : _this.deliverTime.format("YYYY-MM-DD"),
                                deliverTimestamp: _this.deliverTime == null ? null : _this.deliverTime.valueOf(),
                                remark: _this.remark
                            })
                        }
                    })
                    if(incomingNum != 0){
                        this.incomingData.push({
                            name: info.file.name + "_" + timestamp,
                            isShow: false,
                            searchInput: '',
                            filteredData: incomingList,
                            data: incomingList
                        })
                    }
                    this.$message.success('文件上传成功，导入设备' + incomingNum + '台，重复设备' + repeatNum + '台')
                }else if(info.file.status === 'error'){
                    this.$message.error('文件上传失败')
                }
            },
            beforeUpload (file) {
                if(file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                    this.$message.error('请上传.xlsx类型的文件')
                    return false
                }
                return true
            },
            downloadExample(){
                let tHeader = ['IMEI','IMSI','ICCID', 'EXTRA', 'phoneNo'];
                let exportData = [['861122334455007','460041811600012','898607B8181790015012', 'ab43efg112323fes21', '13546984265'],['861122334455409','460041819727291','898607B8181880027291', 'abcdefg12231321', '18965421359']];
                export_json_to_excel(tHeader, exportData, '设备入库模板');
            },
            onSearch(index) {
                this.incomingData[index].filteredData = this.incomingData[index].data.filter(item => item.key.indexOf(this.incomingData[index].searchInput) != -1)
            },
            changeShow(index) {
                this.incomingData[index].isShow = !this.incomingData[index].isShow
            },
            onDelete(key,index) {
                this.incomingData[index].data = this.incomingData[index].data.filter(item => item.key !== key)
                this.incomingData[index].filteredData = this.incomingData[index].filteredData.filter(item => item.key !== key)
                if(index != 0 && this.incomingData[index].data.length == 0){
                    this.incomingData.splice(index,1)
                }
            },
            addStore() {
                let imei = this.imei.value
                let _this = this
                this.imei = {
                    ...ValidUtils.checkImei(imei),
                    value:imei
                }
                // let imsi = this.imsi.value
                // this.imsi = {
                //     ...ValidUtils.checkImsi(imsi),
                //     value:imsi
                // }
                // let iccid = this.iccid.value
                // this.iccid = {
                //     ...ValidUtils.checkIccid(iccid),
                //     value:iccid
                // }
                // let extra = this.extra.value
                // this.extra = {
                //     ...ValidUtils.checkExtra(extra),
                //     value: extra
                // }
                _this.incomingData.map(function(record){
                    if(record.data.length !== record.data.filter(subItem => subItem.key !== _this.oui.value + "_" + imei).length){
                        _this.imei.validateStatus = 'error'
                        _this.imei.errorMsg = 'IMEI号重复'
                    }
                })

                if(this.imei.validateStatus == "success"){
                    this.incomingData[0].data.push({
                        key: this.oui.value + "_" + this.imei.value,
                        imei: this.imei.value,
                        imsi: this.imsi.value,
                        iccid: this.iccid.value,
                        extra: this.extra.value,
                        phoneNo: this.phoneNo.value,
                        orgId: _this.orgOption.orgId,
                        orgName: _this.orgOption.name,
                        oui: this.oui.value,
                        modelId : this.deviceType.value,
                        modelName:  this.deviceType.modelName,
                        version: this.version.value,
                        length: this.length.value,
                        store: this.store.value,
                        createTime: this.createTime == null ? null : this.createTime.format("YYYY-MM-DD"),
                        createTimeStamp: this.createTime == null ? null : this.createTime.valueOf(),
                        paymentTime: this.paymentTime == null ? null : this.paymentTime.format("YYYY-MM-DD"),
                        paymentTimestamp: this.paymentTime == null ? null : this.paymentTime.valueOf(),
                        deliverTime: this.deliverTime == null ? null : this.deliverTime.format("YYYY-MM-DD"),
                        deliverTimestamp: this.deliverTime == null ? null : this.deliverTime.valueOf(),
                        remark: this.remark
                    })
                    this.onSearch(0)
                    this.imei.value = ''
                    this.imsi.value = ''
                    this.iccid.value = ''
                    this.extra.value = ''
                    this.phoneNo.value = ''
                }else{
                    setTimeout(function(){
                        _this.imei.validateStatus = "success"
                        _this.imei.errorMsg = null
                    },5000)
                    // setTimeout(function(){
                    //     _this.imsi.validateStatus = "success"
                    //     _this.imsi.errorMsg = null
                    // },5000)
                    // setTimeout(function(){
                    //     _this.iccid.validateStatus = "success"
                    //     _this.iccid.errorMsg = null
                    // },5000)
                    // setTimeout(function(){
                    //     _this.extra.validateStatus = "success"
                    //     _this.extra.errorMsg = null
                    // },5000)
                }
            },
            // 设备完成注册的回调
            reginComplete (data) {
                // console.log(data)
                // 关闭注册进度条
                this.showReginStep = false
                this.isIncomingStore = false
                this.$message.success('设备入库完成')
                this.$emit('storeSuccess')
            },
            handleOk() {
                let incomingList = []
                this.incomingData.map(function(list){
                    list.data.map(function(item){
                        let device = {}
                        let deviceEx = {}
                        let attrs = {}
                        deviceEx.imei = item.imei
                        deviceEx.imsi = item.imsi
                        deviceEx.length = item.length
                        deviceEx.iccid = item.iccid
                        deviceEx.phoneNo = item.phoneNo
                        deviceEx.version = item.version
                        let deviceModel = {}
                        deviceModel.id = item.modelId
                        deviceEx.deviceModel = deviceModel
                        deviceEx.repository = item.store
                        deviceEx.paymentTimestamp = item.paymentTimestamp ? (item.paymentTimestamp /1000).toFixed(0) : null
                        deviceEx.createTimestamp = item.createTimeStamp ? (item.createTimeStamp /1000).toFixed(0) : null
                        deviceEx.deliverTimestamp = item.deliverTimestamp ? (item.deliverTimestamp /1000).toFixed(0) : null
                        deviceEx.attrs = attrs
                        deviceEx.remark = item.remark
                        if(list.name == '手动添加'){
                            attrs.batchNo = 'manual',
                            attrs.extra = item.extra
                        }else{
                            attrs.batchNo = list.name,
                            attrs.extra = item.extra
                        }
                        device.deviceExtension = deviceEx
                        device.oui = item.oui
                        device.sn = item.imei
                        device.org = {id:item.orgId}
                        incomingList.push(device)
                    })
                })
                if(incomingList.length == 0){
                    this.$message.error('尚未添加入库的设备')
                }else{
                  console.log(incomingList)
                  // debugger
                    this.$http.post(config.api.device_store_url,incomingList).then((res) => {
                        // console.log(res)
                        // 显示注册设备的进度条
                        this.reginTotal = incomingList.length
                        this.showReginStep = true
                        // 关闭注册进度条
                        // this.showReginStep = false
                        // this.isIncomingStore = false
                        // this.$message.success('设备入库成功')
                        // this.$emit('storeSuccess')
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>

